/**
 * @fileoverview Event Dialog - Popup dialog for add/edit event
 *
 * @author Chris Williams (cwilliams@yext.com)
 */
goog.module('yext.social.post.EventDialog');
goog.module.declareLegacyNamespace();

const object = goog.require('goog.object');
const string = goog.require('goog.string');
const yext = goog.require('yext');
/** @suppress {extraRequire} */
goog.require('yext.plugins.inputchange');
const DateTimeInput = goog.require('yext.social.post.DateTimeInput');
const templates = goog.require('yext.templates');
const eventTitle = goog.require('yext.social.Social.eventDialogTitle');
const CharacterCounter = goog.require('yext.textutil.CharacterCounter');
/**
 * @constructor
 * @param {function()} onSubmit
 */
const EventDialog = function(onSubmit) {
  this.onSubmit_ = onSubmit;
};

/** @constant {number} */
EventDialog.MAX_TITLE_LENGTH = 58;

/**
 * @private
 * @param {object<string, ?>} event
 * @return {object<string, ?>}
 */
EventDialog.prototype.validate_ = function(event) {
  var errors = {};
  if (!event['title'] || string.isEmptyOrWhitespace(event['title'])) {
    errors['title'] = yext.msg('Title is required.');
  } else if (event['title'].length > EventDialog.MAX_TITLE_LENGTH) {
    errors['title'] = yext.msg('Title must be at most 58 characters.');
  }
  if (!event['startTime']) {
    errors['startTime'] = yext.msg('Start date and time are required.');
  }
  if (event['endTime'] && event['endTime'] < event['startTime']) {
    errors['endTime'] = yext.msg('End time cannot be before start time.');
  }
  return errors;
};

/**
 * @param {object<string, ?>} event
 * @param {object<string, ?>} errors
 * @param {boolean} addEvent
 * @suppress {deprecated}
 */
EventDialog.prototype.show = function(event, errors, addEvent) {
  addEvent = addEvent || !event;
  var actionText = addEvent ? yext.msg('Add Event') : yext.msg('Edit Event');

  errors = errors || {};
  // Deep copy model object before mutating it. Makes cancel easy.
  event = $.extend(true, {}, event);

  var title = event['title'];

  var startInput = new DateTimeInput(function(datetime) {
    event['startTime'] = datetime;
  });

  var endInput = new DateTimeInput(function(datetime) {
    event['endTime'] = datetime;
  });

  var $titleInput = $('<input>',
    {
      'class': 'event-title-input',
      'type': 'text',
      'val': title,
      'inputchange': function(e) {
        event['title'] = e['target']['value'];
      },
    });

  var $formInput =
      $('<div>',
        {
          'class': 'event-dialog-form-input',
          'append': [
            $('<div>',
              {
                'class': 'event-dialog-title',
                'append': [
                  $('<div>',
                    {
                      'class': 'event-dialog-title-prompt',
                      'text': yext.msg('Event Title'),
                    }),
                  $('<div>',
                    {
                      'class': 'event-error',
                      'text': errors['title'] || '',
                    }),
                  $titleInput,
                ],
              }),
            $('<div>',
              {
                'class': 'event-time-wrapper',
                'append': [
                  $('<div>',
                    {
                      'class': 'event-time-picker',
                      'append': [
                        $('<div>',
                          {
                            'class': 'event-time-title',
                            'text': yext.msg('Start Time *')}),
                        $('<div>',
                          {
                            'class': 'event-error',
                            'text': errors['startTime'] || ''}),
                        startInput.buildElement(event['startTime']),
                      ],
                    }),
                  $('<div>',
                    {
                      'class': 'event-time-picker',
                      'append': [
                        $('<div>',
                          {
                            'class': 'event-error',
                            'text': errors['endTime'] || ''}),
                        $('<div>',
                          {
                            'class': 'event-time-title',
                            'text': yext.msg('End Time')}),
                        endInput.buildElement(event['endTime']),
                      ],
                    }),
                ]}),
            $('<div>',
              {
                'class': 'event-time-disclaimer',
                'text': yext.msg(
                  'The same start and end times (e.g., “9am-5pm”) will be shown for each location in its respective time zone.',
                ),
              }),
          ],
        });

  var $form;
  var $formButtons =
      $('<div>',
        {
          'class': 'event-dialog-buttonset',
          'append': [
            $('<button>',
              {
                'type': 'button',
                'class': 'link event-dialog-cancel',
                'click': function() {
                  $form.dialog('close');
                },
                'text': yext.msg('Cancel'),
              }),
            $('<button>',
              {
                'type': 'submit',
                'class': 'button event-dialog-action',
                'text': actionText,
              }),
          ],
        });

  var submit = function() {
    var errors = this.validate_(event);
    if (object.isEmpty(errors)) {
      this.onSubmit_(event);
    } else {
      this.show(event, errors, addEvent);
    }
    $form.dialog('close');
  }.bind(this);

  $form = $('<form>',
    {
      'class': 'event-dialog-form',
      'append': [
        $formInput,
        $formButtons,
      ],
      'on': {
        'submit': function(e) {
          e.preventDefault();
          submit();
        },
      },
    });

  $form.dialog({
    'modal': true,
    'height': 350,
    'width': 600,
    'closeOnEscape': true,
    'dialogClass': 'event-dialog',
    'autoOpen': true,
    'close': function() {
      // Remove lingering DOM nodes.
      $form.empty();
      $form.remove();
    },
  });

  $('.event-dialog span.ui-dialog-title').html(templates.render(eventTitle.title,
    {
      titleMessage: actionText,
    }));

  new CharacterCounter($('.event-title-input'),
    {limit: EventDialog.MAX_TITLE_LENGTH});
};

exports = EventDialog;
